import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import { theme } from '@racedash/shared/mantine'
import { AuthProvider } from './auth/AuthProvider'
import App from './App'
// Order matters. Mantine's stylesheet must land before ours so the things we
// still style ourselves win, and tokens.css before both since both read it.
import '@racedash/shared/tokens.css'
import '@mantine/core/styles.css'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('No #root element')

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <AuthProvider>
        <App />
      </AuthProvider>
    </MantineProvider>
  </StrictMode>,
)
